import type { ReactNode } from 'react';
import React from 'react';
import { styled, theme } from '@components-shared/src/stitches';

export const PageWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div className="m-[0_auto] min-h-[calc(100vh-112px)] w-full max-w-content px-4 md:px-[26px]">
      {children}
    </div>
  );
};

export const MainContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  maxWidth: theme.widths.landingMaxWidth,
  marginBottom: 8,
  paddingX: 0,
  marginX: 'auto',
});

export const Header = styled('div', {
  width: '100%',
});

export const ShareIcons = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  marginLeft: 'auto',
  marginTop: -8,

  '@tablet': {
    marginTop: 0,
  },
});

export const Grid = styled('div', {
  display: 'grid',
  width: '100%',
  gridColumnGap: 18,
  gridAutoFlow: 'column',
  gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
  gridTemplateRows: 'repeat(100, auto)',
});
